<template>
    <component :is="formTag" :action="url" :type="type" v-on="listeners" v-bind="$attrs">
        <slot name="error-summary" v-if="displayErrorSummary">
            <oc-form-error-summary v-bind="errorSummaryOptions" :start-opened="false" />
        </slot>

        <slot>
            <oc-dynamic-structure :schema="schema" />
        </slot>
    </component>
</template>
<script>
export default {
    name: 'oc-form',
    props: {
        model: {
            type: Object,
            required: true
        },
        nested: {
            type: Boolean,
            default: false
        },
        prevent: {
            type: Boolean,
            default: true
        },
        handleSubmit: {
            type: Boolean,
            default: true
        },
        url: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'POST'
        },
        schema: {
            type: Object,
            default: () => ({})
        },
        displayErrorSummary: {
            type: Boolean,
            default: false
        },
        errorSummaryOptions: {
            type: Object,
            default: () => ({})
        },
        formFieldOptions: {
            type: Object,
            default: () => ({})
        }
    },
    provide() {
        return {
            form: this.model,
            formFieldOptions: this.formFieldOptions
        }
    },
    methods: {
        getModel() {
            return this.model
        },
        submit() {
            this.$emit('submit')
        }
    },
    computed: {
        formTag() {
            return this.nested ? 'div' : 'form'
        },
        listeners() {
            let that = this

            let listeners = Object.assign({},
                // We add all the listeners from the parent
                this.$listeners,
                // Then we can add custom listeners or override the
                // behavior of some listeners.
                {
                    submit: function (event) {
                        if( that.prevent ) {
                            event.preventDefault()
                        }

                        if( that.handleSubmit ) {
                            // this.form.POST(this.url).then(
                            //     resp => {
                            //         // TODO
                            //     },
                            //     error => {
                            //         // TODO
                            //     }
                            // )
                        }

                        that.$emit('submit', event)
                    }
                }
            )

            return listeners
        }
    }
}
</script>
